{
    "base": {
        "no_container_element_provided": "No containerElement provided.",
        "no_container_selector_found": "No container selector found.",
        "web_speech_api_not_supported": "Web Speech API not supported.",
        "unsupported_option_ignored": "Unsupported option ignored:"
    },
    "en": {
        "listen_to_this_page": "Listen to this page"
    },
    "fr": {
        "listen_to_this_page": "Écoutez cette page"
    },
    "de": {
        "listen_to_this_page": "Diese Seite anhören"
    }
}
